import { render, staticRenderFns } from "./scoreboard_sets.vue?vue&type=template&id=4aa93f90&scoped=true&"
import script from "./scoreboard_sets.vue?vue&type=script&lang=js&"
export * from "./scoreboard_sets.vue?vue&type=script&lang=js&"
import style0 from "./scoreboard_sets.vue?vue&type=style&index=0&id=4aa93f90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa93f90",
  null
  
)

export default component.exports